export const footerObjOne = {
    img1: require('../../images/logo_2.png'),
    alt1: "ATTOCHRON",
    pp: require('../../docs/Privacy_Policy.pdf'),
    tac: require('../../docs/Terms_of_Use.pdf'),
}